export default __webpack_public_path__ + "static/hairball-390d959599ff1238da843e3b73a52e15.png";